var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLink = function SvgIconLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IconLink_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.264 10.736a1 1 0 1 1 1.414-1.414c.884.884 2.427.885 3.31 0l3.327-3.326a2.344 2.344 0 0 0 0-3.31 2.344 2.344 0 0 0-3.31 0A1 1 0 1 1 8.59 1.27a4.345 4.345 0 0 1 6.139 0 4.345 4.345 0 0 1 0 6.139l-3.326 3.326a4.33 4.33 0 0 1-3.07 1.27 4.33 4.33 0 0 1-3.069-1.27m-.923 5.262a4.33 4.33 0 0 0 3.07-1.27 1 1 0 1 0-1.414-1.413 2.343 2.343 0 0 1-3.31 0 2.344 2.344 0 0 1 0-3.311l3.306-3.307a2.343 2.343 0 0 1 3.311 0 1 1 0 1 0 1.414-1.414 4.345 4.345 0 0 0-6.139 0L1.271 8.59a4.345 4.345 0 0 0 0 6.139 4.33 4.33 0 0 0 3.07 1.269"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconLink_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIconLink;